function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.1,
  cx: 53,
  cy: 53,
  r: 53,
  fill: "#12B549"
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1663_28218)"
}, React.createElement("path", {
  d: "M53 23C69.5685 23 83 36.4315 83 53C83 69.5685 69.5685 83 53 83C36.4315 83 23 69.5685 23 53C23 36.4315 36.4315 23 53 23ZM53 26.75C38.5025 26.75 26.75 38.5025 26.75 53C26.75 67.4975 38.5025 79.25 53 79.25C67.4975 79.25 79.25 67.4975 79.25 53C79.25 38.5025 67.4975 26.75 53 26.75ZM63.7399 43.625L66.3915 46.2766L50.4816 62.1866L39.875 51.58L42.5266 48.9283L50.4803 56.8819L63.7399 43.625Z",
  fill: "#12B549"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_1663_28218"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "white",
  transform: "translate(23 23)"
})));
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};
export default __webpack_public_path__ + "static/media/successCheck.5e586b2c.svg";
export { SvgComponent as ReactComponent };